import { PipeTransform, Pipe } from "@angular/core";

@Pipe({name: 'commaSeparatedNumber'})
export class CommaSeparatedNumberPipe implements PipeTransform {
  transform(val: string, args: string[]): any {
    val = val + "";
    val = val.replace(/,/g, "");
    if (val.length > 3) {
        let reversed = this.reverseString(val);
        reversed = this.addCommas(reversed);
        reversed = this.reverseString(reversed);
        return reversed;
    }
    return val;
  }
  reverseTransform(val: string, args: string[]): any {
      return val.replace(/,/g, "");
  }

  reverseString(str): string {
    const reversed = str.split("");
    let reverse_index = str.length - 1;
    for (let i = 0; i < str.length / 2; i++) {
        const temp = reversed[i];
        reversed[i] = reversed[reverse_index];
        reversed[reverse_index] = temp;
        reverse_index--;
    }
    return reversed.join("");
  }
  addCommas(str: string): string {
    const split_arr = str.split(".");
    let split_digits = split_arr[0].split("");
    if (split_arr.length == 2) {
        split_digits = split_arr[1].split("");
    }
    let commaBuffer = 3;
    // let indian_switch = true;
    const comma_added_arr = split_digits.map((val, i) => {
        if (commaBuffer == 0) {
            commaBuffer = 1;
            return "," + val;
        }
        commaBuffer--;
        return val;
    });
    if (split_arr.length == 2) {
        split_arr[1] = comma_added_arr.join("");
    } else {
        split_arr[0] = comma_added_arr.join("");
    }
    return split_arr.join(".");
    }
}




// WEBPACK FOOTER //
// ./src/app/modules/shared/pipes/CommaSeparatedNumberPipe.ts